import axios from "axios";
import { registerApiErrorReport } from "../Components/Errors/errorReporter";
const checkEnvironment = (url, apiUrl) => {
  const Environment = process.env.NODE_ENV;
  if (Environment === "development") return url + apiUrl;
  if (Environment === "production")
    return window.env.REACT_APP_API_HOST + apiUrl;
};
const _basic = window.env.REACT_APP_API_DEVELOPMENT_HOST;
const _getStore = "/Store";
const getStore = axios.create({
  baseURL: checkEnvironment(_basic, _getStore)
});

registerApiErrorReport(getStore);

/**
 *
 * @param {number} langId 語系代號
 */

export const getAllStore = async langId => {
  return await getStore.get("/GetStoreAll", { params: { languageID: langId } });
};

export const getOnlyStore = ( storeID, languageID ) => {
  return getStore.get('/GetStoreOnly', { 
    params: { 
      storeID, 
      languageID
    }
  })
}